export default "__VITE_ASSET__0012fe7b__"